<template>
  <div>
    <br/>
    <br/>
    <br/>
    <br/>
    <h1>Oops!</h1>
    <br/>
    <br/>
    <br/>
    <br/>
    <h3>{{ $t('pageNotFound') }}</h3>
    <br/>
    <br/>
    <a v-if="env === 'production'" href="//expar.si" data-qa="homaPageButton" class="info-btn">{{ $t('homepage') }}</a>
    <a v-else href="//demo.expar.si" data-qa="homaPageButton" class="info-btn">{{ $t('homepage') }}</a>

  </div>
</template>

<script>

export default {
  metaInfo: {
    title: '404' ,
  },
  data() {
    return {
      env: ''
    }
  },
  props: {
    resource: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.env = process.env.NODE_ENV
  }
}
</script>

<style scoped>

h3 {
  padding: 0.5em;
}
.info-btn
{
  color: #fff;
  background: var(--primary);
  text-decoration: none !important;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 2px;
  padding: 10px 20px;
  border-radius: 5px;
  transition: 0.3s;
  transition-property: background;
}

.info-btn:hover{
  background: #0C4F60;
}
</style>
